"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SavedJobListQuerySchema = void 0;
const schemas_1 = require("../../../../schemas");
exports.SavedJobListQuerySchema = schemas_1.PaginationQuerySchema;
